const MAIN_PARTNER_NAME = "ARLabs";
export { MAIN_PARTNER_NAME };
